import React from 'react';
import { ReactFlow, Background, BackgroundVariant } from '@xyflow/react';
import '@xyflow/react/dist/style.css';

const BaseReactFlow = ({
  nodes,
  edges,
  nodeTypes,
  edgeTypes,
  watermarkText,
  showBackground = true,
  backgroundVariant = BackgroundVariant.Lines,
  backgroundGap = 20,
  backgroundSize = 1,
  backgroundColor = 'rgba(0,0,0,0.15)',
  className = '',
  proOptions = { hideAttribution: true },
  preventScrolling = false,
  children,
  ...rest
}) => {
  return (
    <>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        proOptions={proOptions}
        className={className}
        deleteKeyCode={['Backspace', 'Delete']}
        autoPanOnConnect={false}
        autoPanOnNodeDrag={false}
        preventScrolling={preventScrolling}
        {...rest}
      >
        {showBackground && (
          <Background
            variant={backgroundVariant}
            gap={backgroundGap}
            size={backgroundSize}
            color={backgroundColor}
          />
        )}
        {children}
      </ReactFlow>
      {watermarkText && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%) rotate(-35deg)',
            fontSize: '144px',
            fontWeight: 'bold',
            color: '#ff364a0f',
            fontFamily: "'Poppins', sans-serif",
            zIndex: 10,
            pointerEvents: 'none',
            whiteSpace: 'nowrap',
            textTransform: 'capitalize',
            letterSpacing: '4px',
            userSelect: 'none',
          }}
        >
          {watermarkText}
        </div>
      )}
    </>
  );
};

export default BaseReactFlow;
